import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface SessionUser {
  id: string;
  email: string;
  fullName: string;
  roles: string[];
  permissions: string[];
  companyScope: string[];
  activeCompanyId?: string;
}

interface AuthState {
  user: SessionUser | null;
  accessToken: string | null;
  activeCompanyId: string | null;
  setUser: (user: SessionUser) => void;
  setAccessToken: (token: string | null) => void;
  setActiveCompanyId: (companyId: string) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      accessToken: null,
      activeCompanyId: null,
      setUser: (user) =>
        set((state) => ({
          user,
          activeCompanyId:
            user?.activeCompanyId ??
            state.activeCompanyId ??
            (Array.isArray(user?.companyScope) ? user.companyScope[0] : null) ??
            null,
        })),
      setAccessToken: (accessToken) => set({ accessToken }),
      setActiveCompanyId: (activeCompanyId) => set({ activeCompanyId }),
      logout: () => set({ user: null, accessToken: null, activeCompanyId: null }),
    }),
    { name: 'erp-auth' },
  ),
);
